import { combineReducers } from 'redux';

import {
    ProductDetailAttributeReducerState,
    productDetailAttributeReducer,
} from '../attributes/store/product-detail-attributes-reducer';
import { ProductDetailFilesReducerState, productDetailFilesReducer } from '../files/store/product-detail-files-reducer';
import {
    ProductDetailOverviewReducerState,
    productDetailOverviewReducer,
} from '../overview/store/product-detail-overview-reducer';
import {
    ProductDetailPricesReducerState,
    productDetailPricesReducer,
} from '../prices/store/product-detail-prices-reducer';
import {
    ProductDetailVariantsReducerState,
    productDetailVariantsReducer,
} from '../variants/store/product-detail-variants-reducer';

export interface ProductDetailReducerState {
    overview: ProductDetailOverviewReducerState;
    files: ProductDetailFilesReducerState;
    attributes: ProductDetailAttributeReducerState;
    prices: ProductDetailPricesReducerState;
    variants: ProductDetailVariantsReducerState;
}

export const productDetailReducer = combineReducers<ProductDetailReducerState>({
    overview: productDetailOverviewReducer,
    files: productDetailFilesReducer,
    attributes: productDetailAttributeReducer,
    prices: productDetailPricesReducer,
    variants: productDetailVariantsReducer,
});
